import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const audiences = [{
  title: 'Insegnanti con allieve bloccate',
  desc: 'Intermediate e avanzate che ripetono sempre le stesse cose senza progredire al livello successivo.'
}, {
  title: 'Insegni in accademia, studio o palestra',
  desc: 'Con una sbarra, uno spazio e le allieve giuste ti basta. Senza attrezzatura costosa.'
}, {
  title: 'Insegnanti che vogliono professionalizzarsi',
  desc: 'Vuoi trasmettere la tua conoscenza e diventare una coach di ballet riconosciuta e autorevole.'
}, {
  title: 'Cerchi un sistema completo e professionale',
  desc: 'Vuoi lezioni strutturate, coreografie pronte e programmi di progressione reali da seguire.'
}];
export function TargetAudience() {
  return <section className="py-16 md:py-24 bg-ballet-50" data-id="element-219">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-220">
        <div className="text-center mb-10 md:mb-16" data-id="element-221">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-charcoal mb-4 md:mb-6" data-id="element-222">
            PER CHI È?
          </h2>
          <p className="text-lg md:text-xl text-gray-600" data-id="element-223">
            Progettato per te se vuoi portare il tuo insegnamento al livello
            successivo.
          </p>
        </div>

        <div className="space-y-4 md:space-y-6" data-id="element-224">
          {audiences.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white p-5 md:p-8 rounded-2xl shadow-sm border border-ballet-100 flex gap-4 md:gap-6 items-start group transition-all duration-300 hover:shadow-md hover:border-ballet-200" data-id="element-225">
              <div className="bg-ballet-100 p-2 rounded-full flex-shrink-0 mt-1 transition-colors duration-300 group-hover:bg-ballet-200" data-id="element-226">
                <Check className="w-5 h-5 md:w-6 md:h-6 text-ballet-600" data-id="element-227" />
              </div>
              <div data-id="element-228">
                <h3 className="text-lg md:text-xl font-bold text-charcoal mb-1 md:mb-2" data-id="element-229">
                  {item.title}
                </h3>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed" data-id="element-230">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-8 md:mt-12 text-center bg-ballet-100/50 p-5 md:p-6 rounded-xl border border-ballet-200" data-id="element-231">
          <p className="text-base md:text-lg font-medium text-ballet-800" data-id="element-232">
            Non sei sicura se fa per te? Hai{' '}
            <strong className="font-bold" data-id="element-233">
              7 giorni di garanzia completa.
            </strong>
          </p>
        </div>
      </div>
    </section>;
}